import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { HeroPage } from '@/components/HeroPage'
import { Section } from '@/components/ui/Section'
import { Container } from '@/components/ui/Container'
import { MethodTimeline } from '@/components/MethodTimeline'
import { ContactCTA } from '@/components/sections/ContactCTA'

export function Method() {
  const { t } = useTranslation()
  const processoRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    // Centra la viewport sulla sezione Processo Produttivo dopo il caricamento
    const timer = setTimeout(() => {
      processoRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }, 100)
    return () => clearTimeout(timer)
  }, [])

  return (
    <main>
      <HeroPage
        title={t('method.hero.title')}
        subtitle={t('method.hero.subtitle')}
        backgroundImage="/images/general/hero_metodo.png"
        breadcrumb={[{ label: t('nav.method') }]}
      />

      {/* Timeline Section */}
      <div ref={processoRef}>
        <Section spacing="xl">
          <Container>
            <MethodTimeline />
          </Container>
        </Section>
      </div>
      <ContactCTA />
    </main>
  )
}
